export default __webpack_public_path__ + "static/media/learning.e45f8659.svg";